import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Subject } from 'rxjs';
import { SystemService } from './system.service';
import * as decode from "jwt-decode";
import { ShoppingCartService } from '../../shopping-cart/service/shopping-cart.service';
declare var localStorage: any;
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private accessToken: string = null;
  private currentUser = null;
  private userLoaded = new Subject<any>();
  public userLoaded$ = this.userLoaded.asObservable();

  // ensure do not load if it is in the promise
  // because many component use get current user function
  private _getUser: any;

  constructor(private restangular: Restangular, private sysService: SystemService,

    private cartServce:ShoppingCartService
    ) { }

  getCurrentUser() {
    if (this.currentUser) {
      return new Promise(resolve => resolve(this.currentUser));
    }

    if (this._getUser && typeof this._getUser.then === 'function') {
      return this._getUser;
    }

    this._getUser = this.restangular
      .one('users', 'me')
      .get()
      .toPromise()
      .then(resp => {
        this.currentUser = resp.data;
        this.userLoaded.next(resp.data);
        this.sysService.setUserLang(this.currentUser.emailLanguageDefault)
        this.cartServce.loadActiveCart();
        return this.currentUser;
      });
    return this._getUser;
  }

  login(credentials: any): Promise<any> {
    credentials.referralCode = window['localStorage']?.getItem('ref');

    return this.restangular
      .all('auth/login')
      .post(credentials)
      .toPromise()
      .then(resp => {
        window['localStorage']?.setItem('accessToken', resp.data.token);
        window['localStorage']?.setItem('isLoggedin', 'yes');
        window['localStorage']?.removeItem('ref');
        this.cartServce.loadActiveCart();

        return this.restangular
          .one('users', 'me')
          .get()
          .toPromise()
          .then(res => {
            this.currentUser = res.data;
            window['localStorage']?.setItem('isLoggedin', 'yes');
            this.userLoaded.next(res.data);
        return res.data;
          });
      });
  }

  register(info: any): Promise<any> {
    info.referralCode = window['localStorage']?.getItem('ref');
    return this.restangular.all('auth/register').post(info).toPromise();
  }

  getAccessToken(): any {
    if (!this.accessToken) {
      this.accessToken = window['localStorage']?.getItem('accessToken');
    }

    return this.accessToken;
  }

  getCurrentUserType() {
    return (decode.default(this.getAccessToken()) as any).type
  }

  forgot(email: string): Promise<any> {
    return this.restangular.all('auth/forgot').post({ email }).toPromise();
  }

  removeToken() {
    window['localStorage']?.removeItem('accessToken');
    window['localStorage']?.removeItem('isLoggedin');
  }

  isLoggedin() {
    return window['localStorage']?.getItem('isLoggedin') === 'yes';
  }

  registerTutor(info: any): Promise<any> {
    info.referralCode = window['localStorage']?.getItem('ref');
    return this.restangular.all('tutors/register').post(info).toPromise();
  }
}
